import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { FieldError } from "./FieldError";

interface FieldProps {
  label?: ReactNode;
  error?: string | string[];
  hint?: string;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

export function Field({ label, error, hint, required, children, className }: FieldProps) {
  return (
    <div className={cn("space-y-2", className)}>
      {label && (
        <label className="ml-1 text-[10px] font-black uppercase tracking-widest text-gray-400">
          {label}
          {required && <span className="ml-1 text-rose-500">*</span>}
        </label>
      )}
      {children}
      {hint && !error && <p className="ml-1 text-[10px] font-medium text-gray-400">{hint}</p>}
      {error && <FieldError errors={Array.isArray(error) ? error : [error]} />}
    </div>
  );
}
